/**
 * Compact badge used in details views (status, tags).
 */

import * as React from 'react';
import { type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Props for {@link DetailBadge}. */
interface DetailBadgeProps {
  label: string;
  icon: LucideIcon;
  colorName:
    | 'color-1'
    | 'color-2'
    | 'color-3'
    | 'color-4'
    | 'color-5'
    | 'color-6'
    | 'success'
    | 'error'
    | 'pending'
    | 'neutral'
    | 'male'
    | 'female';
  variant: 'filled' | 'outlined';
  className?: string;
}

/** Badge used in entity details views. */
export const DetailBadge: React.FC<DetailBadgeProps> = ({
  label,
  icon: Icon,
  colorName,
  variant,
  className,
}) => {
  const badgeClass = cn('detail-badge', `detail-badge-${variant}-${colorName}`, className);

  return (
    <div className={badgeClass}>
      <Icon className="w-4 h-4" />
      <span className="text-sm font-medium">{label}</span>
    </div>
  );
};
